import React from 'react';
import iconSrc from 'images/extension_empty_state.svg';

class RelatedUrlsBlankSlate extends React.Component {
  render() {
    return (
      <div className="RelatedUrlsTableBody FlexboxTable-body">
        <div className="FlexboxTable-row jc-c p-50">
          <div className="Wrapper--thin ta-c fz-bigger c-brand-gray-darker">
            <img
              role="presentation"
              className="mh-300"
              src={iconSrc}
              alt={this.props.i18n.b_s_title}
            />
            <h2 className="ff-ss mt-24">{this.props.i18n.b_s_title}</h2>
            <div className="mt-8">{this.props.i18n.b_s_desc}</div>
            <div className="mt-24">
              {this.props.i18n.b_s_call_to_action}
              &nbsp;
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
              <span
                className="c-brand-blue td-u c-p"
                onClick={this.props.showNewMappingForm}
              >
                {this.props.i18n.b_s_call_to_action_link}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RelatedUrlsBlankSlate;
